// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608281454/js/" + chunkId + "." + {"44":"e2bc3ca7","225":"8a3766c3","481":"687bc944","486":"6200923f","770":"782c5000"}[chunkId] + ".0.25348985336282703.chunk.js";
};